
























import { Breakpoint } from 'vuetify/types/services/breakpoint'
import BreakpointWatcher from '../mixins/breakpoint-watcher'

export default BreakpointWatcher.extend({
  data: () => ({
    watchBreakpoints: 'xs',
    titleTextSize: '',
    contentTextSize: '',
  }),

  methods: {
    onBreakpointChange(b: Breakpoint) {
      if (b.xs) {
        this.titleTextSize = 'display-1'
        this.contentTextSize = 'body-2'
      } else {
        this.titleTextSize = 'display-2'
        this.contentTextSize = 'body-1'
      }
    },
  },
})
